import { Reducer } from 'redux';
import {
  OrganisationAction,
  OrganisationTypes,
  State,
  initialState,
} from '../types';

const reducer: Reducer<State, OrganisationAction> = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state: any = initialState.organisation,
  action: OrganisationAction,
): State => {
  switch (action.type) {
    case OrganisationTypes.FETCH: {
      const { isLegacyMode: legacyFromSession, ...organisation } =
        action.payload;
      return {
        ...state,
        organisation,
        ...(typeof legacyFromSession === 'boolean'
          ? { isLegacyMode: legacyFromSession }
          : {}),
      };
    }
    case OrganisationTypes.FETCH_AUTH_TYPE:
      return {
        ...state,
        organisation: state.organisation
          ? {
              ...state.organisation,
              authenticationType: action.payload.authenticationType,
            }
          : {
              name: '',
              id: '',
              expiryPeriod: 0,
              authenticationType: action.payload.authenticationType,
            },
      };
    case OrganisationTypes.FETCH_AUTH_ADMIN:
      return {
        ...state,
        authenticationAdmin: {
          ...action.payload,
        },
      };
    case OrganisationTypes.UPDATE_AUTH_TYPE:
      return {
        ...state,
        organisation: state.organisation
          ? {
              ...state.organisation,
              authenticationType: action.payload.authenticationType,
              slug: action.payload.slug,
            }
          : {
              name: '',
              id: '',
              expiryPeriod: 0,
              authenticationType: action.payload.authenticationType,
              slug: action.payload.slug,
            },
        authenticationAdmin: action.payload.authenticationAdmin,
      };
    default:
      return state;
  }
};

export default reducer;
